export default __webpack_public_path__ + "static/media/features_overview.71862ac4.svg";